export const CANCEL_EVENT_BOOKING_ENDPOINT = '/account/CancelEvent';
